'use strict';

/* globals config */

require([
	config.relative_path + '/plugins/nodebb-plugin-ideas-board/static/vendor/vue.js',
], function (Vue) {
	var internals = {};

	Vue.component('upload-note', {
		props: ['note', 'saveNote'],
		data: function () {
			return {
				hasFile: typeof this.note.content.fileUrl !== 'undefined',
			};
		},
		mounted: function () {
			internals.note = this.note;

			if (!this.note.content) {
				this.note.content = {
					fileUrl: '',
					fileName: '',
				};
			}
		},
		methods: {
			onUploadSuccess: function (uploads, params) {
				var fileData = {
					fileUrl: (uploads.response.images[0] || {}).url,
					fileName: params.filename,
				};

				this.saveFileData(fileData);

				this.saveFilePermissions(fileData.fileUrl);
			},
			saveFileData: function (file) {
				this.hasFile = true;
				this.note.content.fileUrl = file.fileUrl;
				this.note.content.fileName = file.fileName;

				this.saveNote();
			},
		},
		template: '<div>' +
			'<a class="upload-note-file" v-if="hasFile" :href="note.content.fileUrl" target="_blank"><i class="fa fa-file-text-o" aria-hidden="true"></i> {{note.content.fileName}}</a>' +
			'<upload-component :has-file="hasFile" :note="note" :on-upload-success="onUploadSuccess" :save-file="saveFileData"></upload-component>' +
			'</div>',
	});
});

